import React from "react"
import { useRouter } from "next/router"

import type { ButtonProps } from "@chakra-ui/react"
import { Button, Flex, forwardRef, Icon, Text } from "@chakra-ui/react"

import { ArrowLeftIcon } from "@supliful/common"

type BackButtonProps = ButtonProps & {
  fallbackRoute?: string
}

export const BackButton = forwardRef<BackButtonProps, "button">(
  ({ fallbackRoute, ...rest }, ref) => {
    const router = useRouter()

    return (
      <Flex align="center" role="group">
        <Button
          variant="unstyled"
          pl={4}
          pr={2}
          colorScheme="secondary"
          ref={ref}
          onClick={() => {
            const hasHistory =
              window.history?.length && window.history.length > 1
            if (hasHistory) {
              router.back()
            } else if (fallbackRoute) {
              router.push(fallbackRoute)
            }
          }}
          {...rest}
        >
          <Icon
            w={{ base: "16px", lg: "20px" }}
            h="auto"
            as={ArrowLeftIcon}
            transition="transform 0.2s ease-in-out"
            _groupHover={{
              transform: "translateX(-0.5rem)",
            }}
          />

          <Text pl={2} fontSize={{ base: 14, lg: 16 }} fontWeight={600}>
            Back
          </Text>
        </Button>
      </Flex>
    )
  },
)
